enum PortalNoteType_Enum
{
    Generic = 0,
    Communication = 1,
    System = 2,
    Positive = 3,
    Negative = 4,
    Alert = 5
}

export default PortalNoteType_Enum;